<template>
  <div 
    class="scoreBoard"
    v-bind:class="{'reduced' : okanMain.scoreReduced}"
    @click="okanMain.scoreReduced = !okanMain.scoreReduced"
    >

    <div
    class="mainBoard"
      v-show="!okanMain.scoreReduced"
    >
    <div class="scoreTop"></div>

    <span>Score : </span>
    <div><span>{{okanMain.score}}</span> / <span>{{okanMain.maxScore}}</span></div>

    </div>


    
  </div>
</template>

<script>
export default {
  name: 'scoreBoard',
  props: {
    okanMain: Object,
  },
    data: function() {
      return {
      }
  },
  methods: {
    
  }
}
</script>


